import { useMemo } from 'react';

import { STALE_TIME } from '@blockworks/platform/api';
import { GetAssetResponse } from '@blockworks/platform/api/research/assets';
import { formatDate, formatUsd } from '@blockworks/ui/charts/utils';
import { FlexBox, ThresholdChart } from '@blockworks/ui/components';

import { priceChartQueries } from '@/api/price-chart/queries';
import { ThresholdUsdTooltip } from '@/components/tooltips/thresholds';
import { getOneDayAgoUnix } from '@/utils/functions/helpers';

const AssetPriceChart = ({ asset }: { asset: GetAssetResponse['data'] }) => {
    const recentTime = useMemo(() => {
        return Math.floor(Date.now() / 1000) + 3600;
    }, []);
    const priceQuery = priceChartQueries.getPriceChart.use({
        variables: {
            slug: asset.cgRef,
            vsCurrency: 'usd',
            from: getOneDayAgoUnix(),
            to: recentTime,
        },
        enabled: !!asset.code,
        select: data =>
            data.prices.map(([date, price]) => ({
                date,
                price,
            })),
        staleTime: STALE_TIME.$1Hour,
    });

    return (
        <div className="min-h-[56px] max-w-full overflow-hidden px-2">
            <FlexBox maxW="full" py={2}>
                <ThresholdChart
                    id={`${asset.cgRef}-chart`}
                    key={`${priceQuery.status}-${asset.cgRef}-chart`}
                    height={40}
                    renderTooltip={ThresholdUsdTooltip}
                    formatX={formatDate}
                    formatLabel={() => `${asset.code.toUpperCase()} Price`}
                    threshold="start"
                    formatY={formatUsd}
                    dateKey="date"
                    keys={['price']}
                    data={priceQuery.data ?? []}
                />
            </FlexBox>
        </div>
    );
};

export default AssetPriceChart;
